import React, { useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { RCWidth, base, deepClone } from '../utils'
import Loading from './Loading'
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useDispatch, useSelector } from 'react-redux';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { redNex } from '../Redux/nexSlice';
import KeywordDensityChart from './KeywordDensityChart';
import KeywordDensityHistogram from './KeywordDensityHistogram';

function KeywordDensity({ nexListn, _nex }) {
    const [data, setData] = useState([])
    const [url, setUrl] = useState('')
    const [noData, setNoData] = useState(false)

    const [isLoading, setIsLoading] = useState(false)
    const [showInfo, setShowInfo] = useState(false);

    const [noInput1, setNoInput1] = useState(false)

    const user = useSelector(state=> state.user.user)
    const nx = useSelector(state=> state.nex.nex)

    const dispatch = useDispatch()

    const toggleInfo = () => {
        setShowInfo(!showInfo);
    };

    function isContentValid(data) {
      const invalidKeywords = [
        "enable javascript",
        "javascript",
        "need enable",
        "run this",
        "this app"
      ];
    
      let invalidCount = 0;
      let totalCount = 0;

      
      for (let i = 0; i < data.length; i++) {
        totalCount++
        const keyword = data[i].keyword.toLowerCase();
        if (invalidKeywords.includes(keyword)) {
          invalidCount++;
        }
      }

      
      if(invalidCount >= 3 ) {
        return false
      } else {
        return true
      }
    }

    const stopWords = [
      "a", "about", "above", "after", "again", "against", "all", "am", "an", "and", "any", "are", "aren't", "as", "at", "be", 
      "because", "been", "before", "being", "below", "between", "both", "but", "by", "can't", "cannot", "could", "couldn't", 
      "did", "didn't", "do", "does", "doesn't", "doing", "don't", "down", "during", "each", "few", "for", "from", "further", 
      "had", "hadn't", "has", "hasn't", "have", "haven't", "having", "he", "he'd", "he'll", "he's", "her", "here", "here's", 
      "hers", "herself", "him", "himself", "his", "how", "how's", "i", "i'd", "i'll", "i'm", "i've", "if", "in", "into", "is", 
      "isn't", "it", "it's", "its", "itself", "let's", "me", "more", "most", "mustn't", "my", "myself", "no", "nor", "not", 
      "of", "off", "on", "once", "only", "or", "other", "ought", "our", "ours", "ourselves", "out", "over", "own", "same", 
      "shan't", "she", "she'd", "she'll", "she's", "should", "shouldn't", "so", "some", "such", "than", "that", "that's", 
      "the", "their", "theirs", "them", "themselves", "then", "there", "there's", "these", "they", "they'd", "they'll", 
      "they're", "they've", "this", "those", "through", "to", "too", "under", "until", "up", "very", "was", "wasn't", 
      "we", "we'd", "we'll", "we're", "we've", "were", "weren't", "what", "what's", "when", "when's", "where", "where's", 
      "which", "while", "who", "who's", "whom", "why", "why's", "with", "won't", "would", "wouldn't", "you", "you'd", 
      "you'll", "you're", "you've", "your", "yours", "yourself", "yourselves", "can", "example", "get"
  ];
  

    const getData = async () => {
        if(url !== '') {
          setNoInput1(false)
          setNoData(false)

          const updateAnalytics = async () => {
            const tool = window.location.pathname.split('/').pop();
            let tools = deepClone(user.analytics.toolsUsage);
        
            if (isNaN(tools[tool]) || tools[tool] == 'NaN') {
                tools[tool] = 1;
            } else {
                tools[tool] = Number(tools[tool]) + 1;
            }
        
            await updateDoc(doc(db, 'users', user.id), { analytics: { toolsUsage: tools } });
        };


            setIsLoading(true)
              fetch(`${base}/res`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  type: 'kd',
                  url: url,
                  userId: user.id
                })
              }).then(res=> res.json()).then(rawData=> {
                if(!isContentValid(rawData)) {
                  setNoData(true)
                  setIsLoading(false)
                  return
                }
                if(rawData[0]?.keyword === 'N/A') {
                  setNoData(true)
                  setIsLoading(false)
                  return
                }
                setData([rawData.filter(item => !stopWords.includes(item.keyword.toLowerCase()))])
                setIsLoading(false)
                dispatch(redNex(nx))
                updateAnalytics()
              })
            } else {
              if(url.trim() === '') setNoInput1(true)
            }
    }

    
  return (
    <KeywordDensityContainer>
        <KeywordDensityInputContainer>
            <div style={{display: 'flex', flexDirection: 'column'}}>
            <h2>
                Keyword Density 
                {false && <button onClick={toggleInfo} style={{ marginLeft: '10px', cursor: 'pointer', border: 'none', background: 'none', outline: 'none' }}>
                    {showInfo ? <RemoveIcon style={{color: 'var(--cntnt-color)'}}/> : <AddIcon style={{color: 'var(--cntnt-color)'}}/>}
                </button>}
            </h2>
            {showInfo && (
                <HeaderSpan>
                    Keyword density refers to the percentage of times a keyword or key phrase appears on a webpage compared to the total number of words on the page. <br />Modern search engine algorithms have become more sophisticated and prioritize natural, high-quality content over keyword stuffing.
                </HeaderSpan>
            )}</div>
            <KeywordDensityInnerInputContainer>
                <div style={{ position: 'relative', marginBottom: '20px' }}>
                    <label style={{ position: 'absolute', transform: 'translateY(-70%)', left: '23px', top: '20%', fontSize: 'small' }}>Your Website or Webpage</label>
                    <input type='url' placeholder='example.com' style={{ marginLeft: '20px', borderColor: noInput1? 'red': ''}} value={url} onChange={e => setUrl(e.target.value)} />
                </div>
                {nx !== 0 && <button onClick={()=> !isLoading? getData() : ()=> {}} style={isLoading ? {backgroundColor: 'lightgray', color: 'gray', cursor: 'not-allowed'}: {}}>{!isLoading ?'Get Data': 'Getting Data ...'}</button>}
                {nx === 0 && <button style={{backgroundColor: 'lightgray', color: 'red', cursor: 'not-allowed'}}>Insufficient Nexilum units!</button>}
            </KeywordDensityInnerInputContainer>
        </KeywordDensityInputContainer>

        {data.length !== 0 && !isLoading && <KeywordDensityResContainer style={{overflowX: 'hidden', overflowY: 'scroll'}}>
            <KeywordDensityRes  style={{alignItems: 'start', justifyContent: 'start'}}>
            <KeywordDensityChart data={data} />
            <KeywordDensityHistogram data={data} />
            </KeywordDensityRes>
            <KeywordDensityRes style={{fontWeight: '400'}}>
                <p style={{width: '190px'}}>Keyword</p>
                <p style={{width: '50px'}}>Count</p>
                {/* <p style={{width: '150px', visibility: 'hidden'}}>In Title</p>
                <p style={{width: '150px', visibility: 'hidden'}}>In Description</p> */}
                <p style={{width: '50px', marginRight: '30px'}}>Weight</p>
            </KeywordDensityRes>

            {/* <div style={{overflowX: 'hidden', overflowY: 'scroll'}}> */}
            {data[0]?.map(k=> {
                return (
                    <KeywordDensityRes>
                                        <p style={{width: '190px', color: 'rgb(255, 77, 112)', fontWeight: 'bold', fontFamily: 'Quicksand'}}>{k.keyword}</p>
                                        <p style={{width: '50px'}}>{k.count}</p>
                                        {/* <p style={{width: '150px', visibility: 'hidden'}}>{k?.inTitle}</p>
                                        <p style={{width: '150px', visibility: 'hidden'}}>{k?.inDesc}</p> */}
                                        <p style={{width: '50px', color: 'rgb(255, 77, 112)', fontWeight: 'bold', marginRight: '20px'}}>{k.weight}%</p>
                    </KeywordDensityRes>
                )
            })}
            {/* </div> */}
        </KeywordDensityResContainer>}

        {isLoading && <Loading />}

        {noData && <ErrorMessage>
        <p>We're having trouble analyzing your content due to a potential issue with page rendering. This might happen if JavaScript is disabled or if the page isn't fully loaded.
          <br></br>
          <br></br>
          To fix this:
          <br></br>
          <br></br>
          1- Ensure JavaScript is enabled in your browser settings.<br></br>
          2- Reload the page and try running the analysis again.<br></br><br></br>
          If the issue persists, please check for any content loading errors or reach out to our support team for further assistance [settings &gt; support]. <br></br>We're here to help!</p>  
        </ErrorMessage>}

        {data.length == 0 && !isLoading && !noData && <Intro>

          <h3>Tool Overview</h3>
          <br />
          <p>
            The Keyword Density Tool analyzes the content of your web page to calculate the frequency of specific keywords. 
            This helps you understand how well your page is optimized for those keywords, ensuring you strike the right balance for SEO without overstuffing.
          </p>
          <br /><br />
          
          <h3>Instructions</h3>
          <br />
          <p>1. Enter the URL of the page you want to analyze</p>
          <p>2. Click "Get Data" to calculate the keyword density on the page</p>
          <br /><br />
          
          <h3>Tips</h3>
          <br />
          <p>Avoid keyword stuffing and aim for a natural use of keywords to maintain good readability and SEO performance</p>

        </Intro>}
    </KeywordDensityContainer>
  )
}

export default KeywordDensity


const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

const KeywordDensityContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${RCWidth};
`


const KeywordDensityInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 2px 2px 16px -8px rgb(239, 239, 239);
  background-color: white;
  margin-inline: 20px;
  padding: 20px;
  margin-top: 25px;
  z-index: 2;

  > div > h2 {
    font-weight: 100;
    margin-bottom: 20px;
  }

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--cntnt-color);
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }

  > div > .select-country {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    margin-left: 20px;
    color: var(--cntnt-color);
  }

  > div > button {
    border: none;
    border-radius: 2px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    padding: 5px;
    margin-left: 60px;
    cursor: pointer;
    background-color: var(--cntnt-color);
    color: white;
  }

  > div > button:hover {
    color: var(--cntnt-color);
    background-color: rgb(239, 239, 239);
  }
`


const KeywordDensityInnerInputContainer = styled.div`
  display: flex;
  margin-top: 20px;

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--cntnt-color);
    padding-left: 100px;
    font-size: medium;
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }
`


const KeywordDensityResContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: white;
  border-radius: 2px;
  z-index: 2;
  margin-bottom: 70px;
  padding-bottom: 10px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.6s ease-in-out forwards;
`


const KeywordDensityRes = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px;
    margin-block: 5px;
    border-bottom: 1px solid rgb(230, 230, 230);
    justify-content: space-between;
`


const HeaderSpan = styled.span`
    font-weight: 300;
    color: var(--cntnt-color);
    font-size: medium;

    opacity: 0;
    animation: ${fadeInAnimation} 0.6s ease-in-out forwards;
`


const ErrorMessage = styled.div`
  display: flex;
  width: 90%;
  padding: 35px;

  > p {
    font-family: 'Quicksand';
    color: white;
  }
`

const Intro = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 20px 20px 20px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

  > h3 {
    color: white;
    font-family: 'Quicksand';
    font-weight: 500;
  }

  > p {
    color: white;
    font-family: 'Quicksand';
    width: 60%;
  }
`